<template>
    <div>
        <b-row>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Fornecedor</label>
                    <model-list-select
                        :list="fornecedores"
                        option-text="nome"
                        option-value="codFornecedor"
                        v-model="fornecedor"
                    >
                    </model-list-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label>Nome do Contrato</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="objeto"
                            max="40"
                            size="md"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Processo do Cliente</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="processoCliente"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Código do Contrato</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="contrato"
                            v-mask="'###/####/AAAA'"
                            max="7"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <!-- <b-col sm="12" md="4">
                <b-form-group>
                    <label>Solicitante</label>
                    <model-list-select
                        :list="solicitantes"
                        option-text="nome"
                        option-value="codFuncionario"
                        v-model="solicitante"
                    >
                    </model-list-select>
                </b-form-group>
            </b-col> -->
        </b-row>
        <b-row>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Data Vigência (DE)</label>
                    <date-picker
                        v-model="dataInicioVigencia"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col> 
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Data Vigência (ATÉ)</label>
                    <date-picker
                        v-model="dataFimVigencia"
                        :config="$datePickerOptions2"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Natureza do Contrato</label>
                    <model-list-select
                        :list="naturezasContrato"
                        v-model="naturezaContrato"
                        option-text="descricao"
                        option-value="codigo"
                    ></model-list-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Situação</label>
                    <model-list-select
                        :list="situacoes"
                        option-text="nome"
                        option-value="codigo"
                        v-model="situacao"
                    >
                    </model-list-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>Status</label>
                    <model-list-select
                        :list="statuses"
                        option-text="nome"
                        option-value="value"
                        v-model="status"
                    >
                    </model-list-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group>
                    <b-button variant="primary" class="mr-3" @click="pesquisar()">
                        <i class="fa fa-search"></i> Pesquisar
                    </b-button>
                    <b-button variant="secondary" @click="limpar()">
                        Limpar
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import ContratosServicos from './ContratosServicos'

export default {
    data() {
        return {
            processo: null,
            contrato: null,
            processoCliente: null,
            objeto: null,
            fornecedores: [],
            fornecedor: null,
            solicitantes: [],
            solicitante: null,
            dataInicioVigencia: null,
            dataFimVigencia: null,
            situacoes: [],
            situacao: null,
            status: null,
            statuses: [{nome: "No Prazo", value: true}, {nome: "Vencido", value: false}],
            naturezasContrato: [
                {
                    codigo: '0',
                    descricao: "Venda"
                },
                {
                    codigo: '1',
                    descricao: "Compra"
                },
                // {
                    // codigo: '2',
                    // descricao: "Ambos"
                // }
            ],
            naturezaContrato: null
        }
    },

    components: {
        ModelListSelect
    },

    methods: {
        obterOpcoesFiltros() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterOpcoesFiltros().then((response) => {
                if (response) {
                    if (response.success) {
                        this.fornecedores = response.data.fornecedores,
                        this.situacoes = response.data.situacoesContrato
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        pesquisar() {
            let filtroDto = {
                contrato: this.contrato,
                processoCliente: this.processoCliente,
                fornecedor: this.fornecedor,
                objeto: this.objeto,
                // solicitante: this.solicitante,
                dataInicioVigencia: this.dataInicioVigencia
                    ? this.$moment(this.dataInicioVigencia, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                dataFimVigencia: this.dataFimVigencia
                    ? this.$moment(this.dataFimVigencia, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : null,
                natureza: this.naturezaContrato,
                idSituacaoContrato: this.situacao,
                noPrazo: this.status
            }
            this.$emit('pesquisar', filtroDto)
        },

        limpar() {
            this.fornecedor = null
            this.objeto = null
            this.processoCliente = null
            this.contrato = null
            this.dataInicioVigencia = null
            this.dataFimVigencia = null
            this.naturezaContrato = null
            this.situacao = null
            this.status = null
            this.pesquisar()
        }
    },

    mounted() {
        this.obterOpcoesFiltros()
    }
}
</script>